import { ApiProvider } from "../Providers/APIProvider";
import { AccommodationDataAccess } from "../Data/AccommodationDataAccess";
import { TestPortals } from "./TestPortals";
import { OuterPortal } from "./OuterPortal";
import { InteractionStatus, useMsal } from "@spt/bezel";
import { Dispatch, SetStateAction } from "react";

export interface DataWrapperProps {
    ShowTestTabs: boolean;
    SiteAdmins: Array<String> | undefined;
    SetSiteAdmins: Dispatch<SetStateAction<String[] | undefined>>;
}

export function DataWrapper(props: DataWrapperProps) {
    const msal = useMsal();

    const _ada = new AccommodationDataAccess(msal.instance);

    // console.log(_ada);

    if (msal.inProgress === InteractionStatus.None) {
        if (props.ShowTestTabs) {
            return (
                <ApiProvider Api={{ Accommodation: _ada }}>
                    <TestPortals SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins}></TestPortals>
                </ApiProvider>
            )
        } else {
            return (
                <ApiProvider Api={{ Accommodation: _ada }}>
                    <OuterPortal SiteAdmins={props.SiteAdmins} SetSiteAdmins={props.SetSiteAdmins}></OuterPortal>
                </ApiProvider>
            );
        }
    }
}
